module.exports = __webpack_public_path__ + "static/media/login_logo.b0d5c643.png";